export { VpIconButton } from './VpIconButton';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpIconButton/index.js